/*****************************************************
 * Packages
 ******************************************************/
import { useDispatch, useSelector } from 'react-redux';
import React, { useContext, useState } from 'react';
/*****************************************************
 * Locals
 ******************************************************/
import { Title, TitleWrap } from './AddSectionModal.stc';
import DefaultElement from './DefaultElement';
import EmptyRowCol from './EmptyRowCol';
import LibraryView from './LibraryView';
import Loading from './Loading';
import Select from '../../Select';
/*****************************************************
 * Store
 ******************************************************/
import {
    getVisibleElements,
    getIsFetchingElements,
} from '../../../../redux/selectors';
import { ElementContext } from '../../../../ElementRenderContext';

const allSections = { EmptyRowCol, LibraryView, DefaultElement };
const { useCallback, useEffect } = React;

const ContentView = ({ type, data = {}, validateMembership }) => {
    const dispatch = useDispatch();
    const { addElement } = useContext(ElementContext);
    const [currentTag, setCurrentTag] = useState('');
    const Component = allSections[data.component];
    const isProvided = data.select ? data.select.includes('provided') : false;
    let elements = useSelector(
        (state) => data.select && getVisibleElements(state, data.select)
    );
    if (!data.select && data.elements) {
        elements = data.elements;
    }

    const isFetching = useSelector(
        (state) => data.select && getIsFetchingElements(state, data.select)
    );

    const filteredElements =
        elements &&
        elements.filter(
            (item) => !currentTag || item.tags.includes(currentTag)
        );

    useEffect(() => {
        data.request && data.request(dispatch);
    }, [dispatch, data]);

    const handleFilter = useCallback(({ value }) => {
        setCurrentTag(value);
    }, []);

    return (
        <>
            <TitleWrap>
                <Title>{data.title}</Title>
                {data.hasDropdown && (
                    <div>
                        <Filters
                            tag={currentTag}
                            elements={elements}
                            onFilter={handleFilter}
                        />
                    </div>
                )}
            </TitleWrap>

            {isFetching && !elements.length && <Loading />}

            {Component ? (
                <Component
                    type={type}
                    data={filteredElements}
                    isProvided={isProvided}
                    addElement={addElement}
                    validateMembership={validateMembership}
                />
            ) : null}
        </>
    );
};

export default React.memo(ContentView);

function Filters({ elements = [], tag, onFilter }) {
    const filters = [
        ...new Set(elements.flatMap((val) => val.tags)),
    ].map((val) => ({ value: val, name: val }));
    filters.unshift({ value: '', name: 'All Blocks' });

    return <Select value={tag} options={filters} onChange={onFilter} />;
}
